import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SELECTABLE_CURRENCIES, type SelectableCurrency } from "@/lib/constants";
import { isSelectableCurrency } from "@/hooks/useCurrency";

interface CurrencySelectProps {
  value: SelectableCurrency;
  onChange: (currency: SelectableCurrency) => void;
}

export function CurrencySelect({ value, onChange }: CurrencySelectProps) {
  return (
    <div className="w-[110px]">
      <Label htmlFor="currency-select" className="sr-only">
        Currency
      </Label>
      <Select
        value={value}
        onValueChange={(v) => {
          if (isSelectableCurrency(v)) {
            onChange(v);
          }
        }}
      >
        <SelectTrigger id="currency-select" className="h-9">
          <SelectValue placeholder="Currency" />
        </SelectTrigger>
        <SelectContent align="end">
          {SELECTABLE_CURRENCIES.map((code) => (
            <SelectItem key={code} value={code}>
              {code}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
